import { LeadStatus, Role } from 'generated/graphql';
import { userRole } from '../../../main/lib/helpers/userRole';
import { LeadFragment } from 'pages/lead/api/fragments/generated/Lead.fragment';

export function isStatusAcceptedFn(lead?: LeadFragment) {
  const isAccepted = lead?.status === LeadStatus.Accepted;
  const isWorkerOrForeman = userRole([Role.Worker, Role.Foreman], lead?.user);
  return isAccepted && isWorkerOrForeman;
}
